import * as Types from '../types-api.generated';

import { MomentStatsFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentStatsVariables = Types.Exact<{
  momentId: Types.Scalars['Int'];
}>;


export type ApiMomentStats = { momentStats: { collectorsCount: number, liveActivityCount: number, totalSales: number, worksCount: number, isSoldOut: boolean, bookmarksCount: number } };



export const ApiMomentStatsDocument = /*#__PURE__*/ `
    query MomentStats($momentId: Int!) {
  momentStats(momentId: $momentId) {
    ...MomentStatsFragment
  }
}
    ${MomentStatsFragment}`;

export const useMomentStats = <
      TData = ApiMomentStats,
      TError = ClientError
    >(
      variables: ApiMomentStatsVariables,
      options?: Omit<UseQueryOptions<ApiMomentStats, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentStats, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentStats, TError, TData>(
      {
    queryKey: ['MomentStats', variables],
    queryFn: apiFetcher<ApiMomentStats, ApiMomentStatsVariables>(ApiMomentStatsDocument, variables),
    ...options
  }
    )};

useMomentStats.getKey = (variables: ApiMomentStatsVariables) => ['MomentStats', variables];

export const useInfiniteMomentStats = <
      TData = InfiniteData<ApiMomentStats>,
      TError = ClientError
    >(
      variables: ApiMomentStatsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentStats, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentStats, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentStats, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentStats.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentStats, ApiMomentStatsVariables>(ApiMomentStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentStats.getKey = (variables: ApiMomentStatsVariables) => ['MomentStats.infinite', variables];


useMomentStats.fetcher = (variables: ApiMomentStatsVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentStats, ApiMomentStatsVariables>(ApiMomentStatsDocument, variables, options);
